<template>
  <b-modal
    ref="modalPropostasVinculadas"
    size="xl"
    no-close-on-backdrop
    hide-footer
    :dialog-class="'alteracao-tamanho-vinculo'"
    :modal-class="'center-modal-vinculo'"
    @hidden="limparDados"
  >
    <template #modal-title>
      <h3
        class="m-0 font-modal-title-vinculo "
      >
        Histórico de propostas
      </h3>
      <span style="font-size: 12px;">Visualize as propostas com vínculo a essa empresa</span>
    </template>
    <b-row>
      <b-col cols="12">
        <vue-good-table
          id="tabelaVinculoProposta"
          ref="tableVinculoProposta"
          mode="remote"
          theme="view"
          :columns="colunas"
          :rows="propostasVinculadas"
          :total-rows="totalLinhas"
          :is-loading.sync="isCarregando"
          :group-options="{
            enabled: true,
            collapsable: true,
          }"
          :pagination-options="{
            enabled: true,
            perPage: 10
          }"
          class="mb-1"
          :row-style-class="'style-dados-vinculo'"
          @on-page-change="onAlterarPagina"
        >
          <template
            slot="table-header-row"
            slot-scope="props"
          >
            <span
              v-if="props.column.field === 'nome'"
              style="font-weight: 400;"
            >
              <div style="display: inline-flex;justify-content: space-between;width: 21.53rem;">
                <div>
                  {{ props.row.numeroProposta }}
                </div>
                <div>
                  <b-btn
                    v-b-tooltip.hover.top
                    title="Abrir proposta em nova aba"
                    size="sm"
                    variant="none"
                    class="btn-actions botao-proposta"
                    @click="abrirCadastroProposta(props.row)"
                  >
                    <font-awesome-icon
                      :icon="faExternalLinkAlt"
                      :class="'text-primary'"
                      style="width:22px"
                    />
                  </b-btn>
                </div>
              </div>
            </span>
            <span
              v-else-if="props.column.field === 'status'"
              class="badge-proposta-vinculo badge"
              :style="'background-color: ' + props.row.corStatus + ';'"
            >
              {{ props.row.status }}
            </span>
            <span
              v-else-if="props.column.field === 'valor'"
              style="font-weight: 400;"
            >
              {{ props.row.valorProposta | converteValor }}
            </span>
            <span
              v-else
              style="font-weight: 400;"
            >
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <!-- Serviços vinculados a proposta -->
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field === 'nome'">
              {{ props.row.nomeServico }}
              <b-btn
                v-if="props.row.servicosConsolidadosChecklist && props.row.servicosConsolidadosChecklist.length > 0"
                v-b-tooltip.hover.top
                title="Serviços consolidados do checklist"
                size="sm"
                variant="none"
                class="btn-actions"
                @click="listaServicosConsolidadosChecklist = props.row.servicosConsolidadosChecklist; $refs.modalServicosConsolidadosChecklist.show()"
              >
                <font-awesome-icon
                  :icon="faLink"
                  :class="'text-primary'"
                  style="width:24px;margin-left: -0.5rem;"
                />
              </b-btn>
            </span>
            <span v-else-if="props.column.field === 'valor'">
              {{ props.row.valorServico | converteValor }}
            </span>
          </template>
          <!-- no records -->
          <div slot="emptystate">
            <p style="text-align:center; margin:0">
              Nenhuma proposta vinculada.
            </p>
          </div>
          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <paginacao-base
              :valor="props"
              :quantidade="10"
            />
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <b-modal
      ref="modalServicosConsolidadosChecklist"
      size="sm"
      hide-footer
      @hidden="listaServicosConsolidadosChecklist = [];"
    >
      <template #modal-title>
        <h4 class="m-0">
          Serviços consolidados do checklist
        </h4>
      </template>
      <div
        v-for="(servico, i) in listaServicosConsolidadosChecklist"
        :key="i"
        class="mt-50"
      >
        <b-row>
          <b-col
            cols="12"
          >
            <span><strong>{{ i + 1 }}.</strong> {{ servico }}</span>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-modal>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.badge-proposta-vinculo {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.th-nome {
  width: 25rem !important;
  font-size: 14px;
}

.botao-proposta {
  margin-top: -0.4rem;
}

.font-modal-title-vinculo {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.45;
}

.alteracao-tamanho-vinculo {
  width: 1200px !important;
}

.center-modal-vinculo {
  display: flex !important;
  justify-content: center !important;
}

.style-dados-vinculo {
  font-size: 14px;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faExternalLinkAlt, faLink } from '@fortawesome/free-solid-svg-icons'
import { isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'
import api from '../../services/api'

export default {
  name: 'PropostasVinculadas',
  components: {
    VueGoodTable,
    FontAwesomeIcon,
    PaginacaoBase: () => import('@/shared/components/paginacao-base/PaginacaoBase.vue'),
  },
  props: {
    empresaId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      faExternalLinkAlt,
      faLink,
      colunas: [
        {
          label: 'Proposta', field: 'nome', sortable: false, thClass: 'th-nome',
        },
        {
          label: 'Status', field: 'status', sortable: false, thClass: 'style-dados-vinculo',
        },
        {
          label: 'Tipo', field: 'tipoProposta', sortable: false, thClass: 'style-dados-vinculo',
        },
        {
          label: 'Enviado', field: 'dataEnvioProposta', sortable: false, thClass: 'style-dados-vinculo',
        },
        {
          label: 'Finalizado', field: 'dataFinalizacaoProposta', sortable: false, thClass: 'style-dados-vinculo',
        },
        {
          label: 'Valor', field: 'valor', sortable: false, thClass: 'style-dados-vinculo',
        },
      ],
      propostasVinculadas: [],
      servidorParams: {
        page: 1,
        perPage: 10,
      },
      totalLinhas: 0,
      isCarregando: false,
      listaServicosConsolidadosChecklist: [],
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.modalPropostasVinculadas.show()
      this.carregarPropostasVinculadas()
    })
  },
  methods: {
    limparDados() {
      this.updateParams({ page: 1 })
      this.totalLinhas = 0
      this.propostasVinculadas = []
      this.$emit('hidden')
    },
    carregarPropostasVinculadas() {
      this.montarGrid()
    },
    onAlterarPagina(params) {
      this.updateParams({ page: params.currentPage })
      this.montarGrid()
    },
    updateParams(newProps) {
      this.servidorParams = { ...this.servidorParams, ...newProps }
    },
    montarGrid() {
      this.isCarregando = true
      api.getPropostasVinculadas(this.empresaId, this.servidorParams.page, this.servidorParams.perPage)
        .then(payload => {
          this.servidorParams.page = payload.data.currentPage || 1
          this.totalLinhas = payload.data.rowCount
          this.propostasVinculadas = payload.data.queryable
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
        .finally(() => {
          this.isCarregando = false
        })
    },
    abrirCadastroProposta(row) {
      if (isAdmin()) {
        if (row && row.propostaId > 0) {
          abrirEmNovaGuia('cadastro-proposta', row.propostaId)
        }
      } else {
        const ability = permitidoAcessarRecurso('proposta')
        if (ability) {
          if (row && row.propostaId > 0 && ability.actions.some(som => som === 'read')) {
            abrirEmNovaGuia('cadastro-proposta', row.propostaId)
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
  },
}
</script>
